import { gql, useMutation } from '@apollo/client';

import type {
  CreateBillingPortalSessionMutation,
  CreateBillingPortalSessionMutationVariables,
} from './__generated__/useCreateBillingPortalSession.gql';

// The url is the whole payload — a short-lived bearer link the caller hands to
// the browser immediately. Nothing here lands in the normalized cache.
const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation CreateBillingPortalSession($input: CreateBillingPortalSessionInput!) {
    createBillingPortalSession(input: $input) {
      url
    }
  }
`;

export const useCreateBillingPortalSession = () => {
  return useMutation<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>(
    CREATE_BILLING_PORTAL_SESSION
  );
};
